let isData = (type)=> {
  return type !== 'object' && type !== 'function' && type !== 'array'
};
let setDifferenceRecursive = (result, propertyName, before, after, count) => {
  count = count-1;
  if (count < 0 || (before == null && after == null)) {
    delete result[propertyName];
    return;
  }

  if (result[propertyName] == null) {
    result[propertyName] = {};
  }
  if (isData(typeof before) || isData(typeof after)) {
    before = before==='' || before == null?null:before;
    after = after==='' || after == null?null:after;

    if (before !== after) {
      result[propertyName].before = before; result[propertyName].after = after
    } else {
      delete result[propertyName]
    }
    return
  } else if (typeof before === 'function' || typeof after === 'function') {
    delete result[propertyName]
    return
  }

  let sortFunction = (a, b) => {
    return a===b?0:a<b?-1:1
  };

  let keysOfBefore = Object.keys(before ? before : {}).sort(sortFunction);
  let keysOfAfter = Object.keys(after ? after : {}).sort(sortFunction);

  let i = 0, j= 0;
  for (; i < keysOfBefore.length || j < keysOfAfter.length;) {
    let b = before ? before[keysOfBefore[i]] : null, a = after ? after[keysOfAfter[j]]: null, p = '';
    if (i >= keysOfBefore.length) {
      b = null;
      p = keysOfAfter[j];
      j++;
    } else if (j >= keysOfAfter.length) {
      a = null;
      p = keysOfBefore[i];
      i++;
    } else if (keysOfBefore[i] === keysOfAfter[j]) {
      p = keysOfBefore[i];
      i++;j++;
    } else if (keysOfBefore[i] < keysOfAfter[j]) {
      p = keysOfBefore[i];
      a = null;
      i++;
    } else {
      p = keysOfAfter[j];
      b = null;
      j++;
    }
    setDifferenceRecursive(result[propertyName], p, b, a, count)
  }
  // for (;i < keysOfBefore.length;i++) {
  //   setDifferenceRecursive(result[propertyName], keysOfBefore[i], before ? before[keysOfBefore[i]] : null, null, count)
  // }
  // for (;j < keysOfAfter.length;j++) {
  //   setDifferenceRecursive(result[propertyName], keysOfAfter[j], null, after ? after[keysOfAfter[j]]: null, count)
  // }

  if (Object.keys(result[propertyName]).length <= 0) {
    delete result[propertyName]
  }
};

export function setDifferenceObject(result, propertyName, before, after) {
  if (result == null) {
    result = {};
  }
  setDifferenceRecursive(result, propertyName, before, after, 5);

  return result
}
